
const DEPOSIT = 'DEPOSIT'
const DEPOSIT1 = 'DEPOSIT_1'
const DEPOSIT2 = 'DEPOSIT_2'
const BALANCE = 'BALANCE'
const CREDIT = 'CREDIT'
const SHIPPING = 'SHIPPING'
const FULL = 'FULL'
const DISCOUNT = 'DISCOUNT'
const TARIFF = 'TARIFF'
const FEE = 'FEE'

const allPaymentTypes = [DEPOSIT, DEPOSIT1, DEPOSIT2, BALANCE, CREDIT, SHIPPING, FULL, DISCOUNT, TARIFF, FEE]
const enumPaymentTypes = {
    [DEPOSIT]: 'Deposit',
    [DEPOSIT1]: 'Deposit 1',
    [DEPOSIT2]: 'Deposit 2',
    [BALANCE]: 'Balance',
    [CREDIT]: 'Credit',
    [SHIPPING]: 'Shipping',
    [FULL]: 'Full',
    [DISCOUNT]: 'Discount',
    [TARIFF]: 'Tariff',
    [FEE]: 'Fee'
}

module.exports = {
    allPaymentTypes,
    enumPaymentTypes,
    DEPOSIT,
    DEPOSIT1,
    DEPOSIT2,
    BALANCE,
    CREDIT,
    SHIPPING,
    FULL,
    DISCOUNT,
    TARIFF,
    FEE
}